export const generatePageNumbers = (
  currentPage: number,
  totalPages: number,
) => {
  const pages: number[] = [1]

  if (totalPages <= 5) {
    for (let i = 2; i <= totalPages; i++) {
      pages.push(i)
    }

    return pages
  }

  if (currentPage < 3) {
    for (let i = 2; i <= 4; i++) {
      pages.push(i)
    }
    pages.push(-1)
  } else {
    pages.push(-1)
    for (
      let i = currentPage;
      i <= Math.min(currentPage + 2, totalPages - 1);
      i++
    ) {
      pages.push(i)
    }
    if (currentPage + 2 < totalPages - 1) {
      pages.push(-1)
    }
  }

  pages.push(totalPages)

  return pages
}
